import React from "react";
import { Container } from "./styles";


export default ({
  addGenerated, //
  addImage,
  zoom,
  generateCTAText = "Generate more like this"
}) => {
  return (
    <Container className="floating-menu" style={{
      // ensure the size of the element remains the same regardless of zoom
      transform: `scale(${1 / zoom}) translateX(-50%)`,
      top: `${-50 * (1 / zoom)}px`
    }}>
      <ul>
        <li>
          <a
            onClick={(e) => {
              e.stopPropagation();
              addGenerated();
            }}
          >
            {generateCTAText}
          </a>
        </li>
        <li>
          <a
            onClick={(e) => {
              e.stopPropagation();
              addImage();
            }}
          >
            Visualize
          </a>
        </li>
      </ul>
    </Container>
  );
};
